module.exports = __webpack_public_path__ + "img/details-head__banner.png?277c7cd1a9b1eca1c076f71e36da3280";